import axios from 'axios';
import apiClient from './apiClient';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

const publicClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

const shopService = {
  getBySlug: async (slug) => {
    const response = await publicClient.get(`/shops/slug/${slug}`);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await apiClient.get('/shops', { params });
    return response.data;
  },

  getActive: async () => {
    const response = await apiClient.get('/shops/active');
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/shops/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/shops', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/shops/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/shops/${id}`);
    return response.data;
  },

  restore: async (id) => {
    const response = await apiClient.patch(`/shops/${id}/restore`);
    return response.data;
  },

  permanentDelete: async (id) => {
    const response = await apiClient.delete(`/shops/${id}/permanent`);
    return response.data;
  },

  seedServices: async (id, sourceShopId) => {
    const response = await apiClient.post(`/shops/${id}/seed-services`, { sourceShopId });
    return response.data;
  },

  seedInspectionItems: async (id, sourceShopId) => {
    const response = await apiClient.post(`/shops/${id}/seed-inspection-items`, { sourceShopId });
    return response.data;
  },

  markAsPaid: async (id) => {
    const response = await apiClient.patch(`/shops/${id}/mark-paid`);
    return response.data;
  },

  undoPayment: async (id) => {
    const response = await apiClient.patch(`/shops/${id}/undo-payment`);
    return response.data;
  },
};

export default shopService;
